/* global objectFitImages */

Wee.fn.make('objectFitImages', {
	init: function() {
		objectFitImages();
	}
});
